import * as React from "react";
import { MediaQuery, Button, Util, Link } from "@grandvisionhq/common";
import { Container, Heading, Text } from "@grandvisionhq/elements";
import { useIntersectionObserver } from "@grandvisionhq/lib-utils-react";
import { BannerTooltip } from "../../../BannerTooltip/components/BannerTooltip/BannerTooltip.js";
/* empty css                   */
const SUPPORTED_STYLES = ["primary", "secondary", "primary outline", "secondary outline"];
const ContentBanner = ({
  image,
  mobileImage,
  title,
  text,
  links,
  textColor = "white",
  tooltip,
  titleSemantic,
  bannerHeight
}) => {
  const isPhone = MediaQuery.useIsPhone();
  const imageUrl = isPhone ? mobileImage?.url : image?.url;
  const imageLink = links.find(({ style: style2 }) => style2 === "image");
  const [ref, inView] = useIntersectionObserver({
    rootMargin: "150px 0px",
    freezeOnceVisible: true
  });
  const btnLinks = React.useMemo(() => {
    return links.filter(({ style: style2 }) => SUPPORTED_STYLES.includes(style2 ?? "")).map(({ url, label, style: style2, target }, i) => /* @__PURE__ */ React.createElement(
      Button,
      {
        key: i,
        href: url,
        caption: label,
        className: "content-banner__button",
        hrefTarget: target === "external" ? "_blank" : void 0,
        ...Util.createButtonStyles(style2)
      }
    ));
  }, [links]);
  if (!image && !title && !text) {
    console.warn("Cannot render ContentBanner: missing content");
    return null;
  }
  const style = {};
  if (inView && imageUrl) {
    style.backgroundImage = `url(${imageUrl})`;
  }
  if (bannerHeight && bannerHeight > 0) {
    style.height = `${bannerHeight}px`;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref,
      className: `content-banner content-banner--color-${textColor}`,
      style,
      "data-t": "content-banner"
    },
    /* @__PURE__ */ React.createElement(Container, { className: "content-banner__container" }, /* @__PURE__ */ React.createElement("div", { className: "content-banner__body" }, title && /* @__PURE__ */ React.createElement(
      Heading,
      {
        className: "content-banner__title",
        component: titleSemantic || "h2",
        variant: "large"
      },
      title
    ), text && /* @__PURE__ */ React.createElement(Text, { className: "content-banner__text" }, text), btnLinks, imageLink && /* @__PURE__ */ React.createElement(
      Link,
      {
        url: imageLink.url,
        target: imageLink.target,
        className: "content-banner__image-link"
      },
      imageLink.label && /* @__PURE__ */ React.createElement("span", { className: "content-banner__image-link-text" }, imageLink.label)
    )), tooltip && /* @__PURE__ */ React.createElement(BannerTooltip, { className: "content-banner__tooltip", tooltip }))
  );
};
export {
  ContentBanner as default
};
//# sourceMappingURL=ContentBanner.js.map
